
import { Input } from '@/components/ui/input';
import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

interface MoneyInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
  required?: boolean;
}

export const MoneyInput = ({ 
  value, 
  onChange, 
  placeholder = "Digite o valor", 
  disabled = false,
  className,
  id,
  required = false
}: MoneyInputProps) => {
  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    if (value && value !== '' && value !== '0') {
      const numericValue = parseFloat(value.toString().replace(/[^\d,.-]/g, '').replace(',', '.'));
      if (!isNaN(numericValue) && numericValue !== 0) {
        const formatted = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(numericValue);
        setDisplayValue(formatted);
      } else {
        setDisplayValue('');
      }
    } else {
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    
    console.log('=== MONEY INPUT CHANGE ===');
    console.log('Raw input value:', inputValue);
    
    // Remove todos os caracteres exceto números
    const numbersOnly = inputValue.replace(/\D/g, '');
    console.log('Numbers only:', numbersOnly);
    
    if (numbersOnly === '') {
      console.log('Empty input, clearing value');
      setDisplayValue('');
      onChange('');
      return;
    }
    
    // Converte centavos para reais
    const numericValue = parseInt(numbersOnly) / 100;
    console.log('Numeric value (reais):', numericValue);
    
    // Formata para exibição com R$
    const formatted = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numericValue);
    
    console.log('Formatted for display:', formatted);
    console.log('Calling onChange with:', numericValue.toString());
    
    setDisplayValue(formatted);
    onChange(numericValue.toString());
  };

  return (
    <Input 
      id={id}
      type="text"
      placeholder={placeholder}
      value={displayValue}
      onChange={handleChange}
      className={cn("text-base rounded-xl [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none", className)}
      required={required}
      disabled={disabled}
    />
  );
};
